var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('big-one',{attrs:{"content":_vm.content,"type":_vm.type,"default-value-filter":_vm.valueFilter,"page-limits":_vm.filterMap,"tuning":"true","a-page":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }